import Vue from 'vue';
import App from './App.vue';
import store from './config/store';
import router from './config/router';
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chips from 'primevue/chips';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Divider from 'primevue/divider';
import Editor from 'primevue/editor';
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import FullCalendar from 'primevue/fullcalendar';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Listbox from 'primevue/listbox';
import InputMask from 'primevue/inputmask';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import OrderList from 'primevue/orderlist';
import OrganizationChart from 'primevue/organizationchart';
import OverlayPanel from 'primevue/overlaypanel';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import ProgressBar from 'primevue/progressbar';
import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import SelectButton from 'primevue/selectbutton';
import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import SplitButton from 'primevue/splitbutton';
// import Spinner from 'primevue/spinner';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import ToggleButton from 'primevue/togglebutton';
import Tree from 'primevue/tree';
import TreeTable from 'primevue/treetable';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import Timeline from 'primevue/timeline';
// import ValidationMessage from 'primevue/validationmessage';
import Steps from 'primevue/steps';
import Tooltip from 'primevue/tooltip';
import VCalendar from 'v-calendar';
import AccountGroup from 'vue-material-design-icons/AccountGroup.vue';


// import 'primevue/resources/themes/nova-light/theme.css';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import '@fullcalendar/core/main.min.css';
import '@fullcalendar/daygrid/main.min.css';
import '@fullcalendar/timegrid/main.min.css';
import './assets/layout/layout.scss';
import './assets/layout/custom.css';


import VueMask from 'di-vue-mask'


import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueGtag from "vue-gtag";


import AppSubmenu from './AppSubmenu';
Vue.directive("appsubmenu", AppSubmenu)

Vue.use(ToastService);
Vue.use(VueMask);

/* IMPLEMENTAÇÃO DO CALENDARIO 
  # site referencia https://vcalendar.io/api/v2.0/calendar.html
*/
 Vue.use(VCalendar);

if(process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS!='false'){
	/* IMPLEMENTAÇÃO DO RECAPTCHA 
	# site referencia https://github.com/AurityLab/vue-recaptcha-v3
	*/
	Vue.use(VueReCaptcha, {
		siteKey: '6Leeq_oUAAAAAH-YQawtsSGHRHGGuZ1sSsjMt5XN',
		loaderOptions: {
			useRecaptchaNet: true
		}
	})

	/* IMPLEMENTAÇÃO DO GOOGLE Analytics
	# site referencia https://matteo-gabriele.gitbook.io/vue-gtag/auto-tracking
	*/ 
	Vue.use(VueGtag, {
		config: { id: "UA-108689723-1" },
		appName: 'Portal Servidor de Mato Grosso'
	}, router);
}

import './config/axios'
import './config/global'

Vue.config.productionTip = false;

// Cria a diretiva de campo requerido para validação do formulário
Vue.directive('required', {
	inserted: function(el) {
		// Altera a cor de fundo com campo para identificar que o preenchimento dele é obrigatório
		const elementAnt = el.parentNode.parentNode;
		const label = elementAnt.getElementsByTagName('label');
		if(label[0]){
			label[0].innerHTML = label[0].innerHTML+ "<span style='color: red;'>*</span>";
		}else{
			el.setAttribute('placeholder',el.getAttribute('placeholder')+'*');
		}
		// el.style.backgroundColor = '#fefdc8'
		// adicona o atributo required para ser monitorado pelo formulario da seplag
		el.setAttribute('required','true')

	}
})
 

Vue.component('Accordion', Accordion);
Vue.component('AccordionTab', AccordionTab);
Vue.component('AutoComplete', AutoComplete);
Vue.component('Button', Button);
Vue.component('Calendar', Calendar);
Vue.component('Card', Card);
Vue.component('Chart', Chart);
Vue.component('Checkbox', Checkbox);
Vue.component('Chips', Chips);
Vue.component('Column', Column);
Vue.component('DataTable', DataTable);
Vue.component('DataView', DataView);
Vue.component('DataViewLayoutOptions', DataViewLayoutOptions);
Vue.component('ColumnGroup', ColumnGroup);
Vue.component('Dialog', Dialog);
Vue.component('Dropdown', Dropdown);
Vue.component('Editor', Editor);
Vue.component('Fieldset', Fieldset);
Vue.component('FileUpload', FileUpload);
Vue.component('FullCalendar', FullCalendar);
Vue.component('InputSwitch', InputSwitch);
Vue.component('InputText', InputText);
Vue.component('InputMask', InputMask);
Vue.component('InputNumber', InputNumber);
Vue.component('Listbox', Listbox);
Vue.component('Menu', Menu);
Vue.component('Menubar', Menubar);
Vue.component('Message', Message);
Vue.component('MultiSelect', MultiSelect);
Vue.component('OrderList', OrderList);
Vue.component('OrganizationChart', OrganizationChart);
Vue.component('OverlayPanel', OverlayPanel);
Vue.component('Paginator', Paginator);
Vue.component('Panel', Panel);
Vue.component('Password', Password);
Vue.component('ProgressBar', ProgressBar);
Vue.component('PickList', PickList);
Vue.component('RadioButton', RadioButton);
Vue.component('Rating', Rating);
Vue.component('SelectButton', SelectButton);
Vue.component('Slider', Slider);
Vue.component('Sidebar', Sidebar);
// Vue.component('Spinner', Spinner);
Vue.component('SplitButton', SplitButton);
Vue.component('TabView', TabView);
Vue.component('TabPanel', TabPanel);
Vue.component('Textarea', Textarea);
Vue.component('Toast', Toast);
Vue.component('Toolbar', Toolbar);
Vue.component('ToggleButton', ToggleButton);
Vue.component('Tree', Tree);
Vue.component('TreeTable', TreeTable);
Vue.component('TriStateCheckbox', TriStateCheckbox);
Vue.component('Timeline', Timeline);
// Vue.component('ValidationMessage', ValidationMessage);
Vue.component('Steps', Steps);
Vue.directive('tooltip', Tooltip);
Vue.component('account-group', AccountGroup);
Vue.component('Divider', Divider);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
